import type { MetaFunction } from '@remix-run/node';
import { useNavigate } from '@remix-run/react';
import { useEffect } from 'react';

export const meta: MetaFunction = () => {
  return [{ title: 'Home - Brighte Enterprise' }];
};

function Index() {
  const navigate = useNavigate();

  useEffect(() => {
    // This is temporary until we have a real home page.
    navigate('/opportunities');
  }, [navigate]);

  return null;
}

export default Index;
